export const SET_INVESTOR_RM_ID = "SET_INVESTOR_RM_ID";
export const CLEAR_SESSION_DATA = "CLEAR_SESSION_DATA";
